module.exports = __webpack_public_path__ + "img/nplex_color.f610650a.svg";